<template>
  <div>
    <transition name="slide-right" v-show="visible">
      <div :class="[
        'tw-w-full tw-grid tw-grid-rows-[auto_1fr_auto] tw-fixed tw-inset-0 md:tw-rounded-l-[12px] tw-bg-white border',
        width === 'tn' && 'md:tw-w-[360px]',
        width === 'sm' && 'md:tw-w-[576px]',
        width === 'md' && 'md:tw-w-[899px]',
      ]"
           :style="{
            'z-index': zIndex+1
            // 'z-index': 1060
           }">
        <header class="tw-flex tw-justify-between tw-items-center tw-min-h-[84px] tw-border-b tw-border-blue-dark-50 tw-text-blue-dark-500 tw-p-6" v-if="headerTitle">
          <div>
            <base-icon :icon="headerIcon" class="fs-21 tw-align-middle tw-ml-3"></base-icon>
            <h3 v-text="headerTitle" class="tw-inline-block !tw-font-bold tw-text-small"></h3>
          </div>
          <div class="tw-flex tw-items-center">
            <base-icon icon="close" class="c-pointer fs-21" @click="close"></base-icon>
          </div>
        </header>

        <!--    Body    -->
        <div class="tw-overflow-hidden" :class="bodyClass">
            <slot name="body" />
        </div>

        <footer class="tw-flex tw-flex-wrap tw-gap-[12px] tw-p-6 tw-pb-5 tw-justify-end tw-min-h-[84px] tw-items-center tw-border-t tw-border-blue-dark-50"
                :class="footerClass">
          <slot name="footer" />
        </footer>
      </div>
    </transition>
    <div
      v-show="visible"
      class="right-sidebar-backdrop"
      :style="{
      'z-index': zIndex,
      // 'z-index': 1059
    }"
      @click.self="close"
    >
    </div>
  </div>
</template>

<script setup>
import {computed, ref, watch, getCurrentInstance} from 'vue'
import BaseIcon from "@/components/base/BaseIcon.vue";

const { proxy } = getCurrentInstance();
const showMoreDetail = ref(false);
const zIndex = ref(null)

const props = defineProps({
  visible: { type: Boolean, default: false },
  headerTitle: { type: String, default: null },
  headerIcon: { type: String, default: 'info-bold' },
  width: { type: String, default: 'sm' },
  bodyClass: { type: String, default: '' },
  footerClass: { type: String, default: '' },
})

const emit = defineEmits(['update:visible', 'close'])

const close = () => {
  emit('update:visible', false)
  emit('close', true)
}

// قفل کردن scroll وقتی بازه
watch(() => props.visible, (val) => {
  document.body.style.overflow = val ? 'hidden' : ''
})

const calc_and_set_z_index = () => {
  zIndex.value = proxy.$getModalZIndex() || 1050
}

watch(() => props.visible, (val) => {
  if (val) {
    calc_and_set_z_index()
    // document.body.style.overflow = 'hidden'
  } else {
    // document.body.style.overflow = ''
  }
})

</script>

<style >
.right-sidebar-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.3);
  display: flex;
  justify-content: flex-start;
  transition: opacity 0.2s ease;
}

.right-sidebar {
  border-radius: 0.75rem 0 0 0.75rem;
  box-shadow: -8px 0px 40px rgba(176, 212, 250, 0.35);
}

.btn-close {
  background: transparent;
  border: none;
  font-size: 18px;
  cursor: pointer;
}

/* انیمیشن باز و بسته شدن */
.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.3s ease, opacity 0.1s ease;
}

.slide-right-enter-from,
.slide-right-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
</style>
